import { Component, OnInit } from '@angular/core';
import { I18ns } from '../../../utils/i18n/I18n';
import { StoreService } from '../../../data/store.service';
import { MsgService } from '../../../utils/message/msg.service';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { SharedModule } from '../../../utils/shared.module';
import { filter, map, of, switchMap, tap } from 'rxjs';
import { ApiService } from '../../../data/api.service';

@Component({
  selector: 'app-theme-details',
  standalone: true,
  imports: [SharedModule, RouterOutlet],
  templateUrl: './theme-details.component.html',
  styleUrl: './theme-details.component.scss',
})
export class ThemeDetailsComponent implements OnInit {
  protected readonly I18ns = I18ns;

  constructor(
    public readonly store: StoreService,
    private readonly msg: MsgService,
    private readonly api: ApiService,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
  ) {}

  ngOnInit() {
    this.route.params
      .pipe(
        map((params) => {
          if (this.store.theme().id !== params['key']) {
            return params['key'];
          }
          return null;
        }),
        filter((key) => !!key),
        switchMap((key) => {
          if (key) {
            return this.api.getTheme(key);
          }
          return of(null);
        }),
        tap((theme) => {
          if (theme) {
            this.store.theme.set(theme);
          }
        }),
      )
      .subscribe();

    if (!this.store.theme()?.id) {
      this.msg.add({
        message: I18ns.grid.noTheme,
        severity: 'error',
      });
      return;
    }
    this.msg.clear();
  }

  goToGamePicker() {
    this.router.navigate(['/k/', this.store.theme()?.id]);
  }
}
